module.exports = __webpack_public_path__ + "img/creative-portfolio.d88792a7.png";